import React, { useContext, useEffect, useMemo, useState } from "react";
import { Badge, Box, Button, Paper, Tooltip, Typography } from "@mui/material";
import DataTableComponent from "../../../../components/common/DataTable/DataTable";
import { generateCataloguesColumns } from "../../helper";
import { useNavigate } from "react-router-dom";
import issue from "../../../../assets/svg/issue.svg";
import SimpleBar from "simplebar-react";
import StoreStepperContext from "../../../../context/storeStepperContext";
import ConfirmationModal from "../../../../components/common/ConfirmationModal/ConfirmationModal";
import {
  arrayRemove,
  deleteDoc,
  doc,
  getDoc,
  updateDoc,
} from "firebase/firestore";
import { db } from "../../../../firebaseConfig";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

function CataloguesList({ storeData, id, refreshValue, refresh }) {
  const navigate = useNavigate();
  const {
    setCheckForEdit,
    setProductIdForEdit,
    setAddProductFromOverview,
    setAddProductFromOverviewDocId,
    setProductCatalog,
    setStoreFormData,
  } = useContext(StoreStepperContext);
  const user = useSelector((state) => state.auth.value);
  const [confirmatioModalState, setConfirmationModalState] = useState({
    showModal: false,
    productId: "",
  });
  const menuOptions = useMemo(
    () => [
      {
        id: "edit",
        iconName: "mdi:square-edit-outline",
        actionName: "Edit",
        onClickHandle: (row) => {
          console.log(row);
          setCheckForEdit(true);
          setProductIdForEdit(row?.productId);
          setAddProductFromOverview(true);
          setAddProductFromOverviewDocId(id);
          navigate("/shopping/store/add-product", {
            state: { id: row?.productId },
          });
        },
      },
      {
        id: "delete",
        iconName: "material-symbols:delete-rounded",
        actionName: "Request For Delete",
        isDisable: false,
        onClickHandle: (row) => {
          setConfirmationModalState((prev) => ({
            showModal: true,
            productId: row?.productId,
          }));
        },
      },
    ],
    []
  );

  const CataloguesColumns = generateCataloguesColumns(menuOptions);
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    if (storeData && storeData?.products && storeData?.products?.length > 0) {
      setTableData(storeData?.products);
    }
  }, [storeData]);

  const cancelHandler = () => {
    setConfirmationModalState({ showModal: false, productId: "" });
  };

  const deleteHandler = async () => {
    try {
      const storeRef = doc(db, "stores", id);

      const storeSnapshot = await getDoc(storeRef);

      if (storeSnapshot.exists()) {
        const storeData = storeSnapshot.data();
        console.log(storeData);
        const productToRemove = storeData.products.find(
          (product) => product.productId === confirmatioModalState.productId
        );

        if (productToRemove) {
          await updateDoc(storeRef, {
            products: arrayRemove(productToRemove),
          });
          refresh(!refreshValue);
          setConfirmationModalState({ showModal: false, productId: "" });
          toast.success("Product deleted successfully!");
        } else {
          console.log("Product not found in the array.");
        }
      } else {
        console.log("Store document does not exist.");
      }
    } catch (error) {
      console.error("Error removing product: ", error);
    }
  };

  return (
    <Box>
      {tableData?.length > 0 && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            margin: "10px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              gap: "10px",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography variant="h4">Product List</Typography>

            <Tooltip
              title={
                <span
                  style={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <span
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      gap: "6px",
                      alignItems: "center",
                    }}
                  >
                    <Badge
                      // color="primary"
                      variant="dot"
                      mr={1}
                      sx={{
                        "& .MuiBadge-badge": {
                          color: "lightgreen",
                          backgroundColor: "blue",
                        },
                      }}
                    />{" "}
                    Parcel Product{" "}
                  </span>
                </span>
              }
              arrow
              placement="bottom"
            >
              <ErrorOutlineIcon />
            </Tooltip>
          </Box>

          <Box>
            <Button
              sx={{
                backgroundColor: "rgba(94, 23, 235, 1)",
                fontWeight: 600,
                color: "white",
                height: "35px",
                borderRadius: "4px",
                paddingX: "14px",
                paddingY: "9px",
                ":hover": {
                  backgroundColor: "rgba(94, 23, 235, 1)",
                },
              }}
              onClick={() => {
                setAddProductFromOverview(true);
                setAddProductFromOverviewDocId(id);
                navigate("/shopping/store/add-product");
                // setCheckForEdit(false);
                // setProductIdForEdit("");
                // setAddProductFromOverview(false);
                // setProductCatalog(false);
                // setStoreFormData((prev) => ({
                //   ...prev,
                //   currentProduct: {
                //     productId: "",
                //     productName: "",
                //     productCategory: "",
                //     productBrand: "",
                //     productPrice: "",
                //     productWeight: "",
                //     productStock: "",
                //     productDimentionL: "",
                //     productDimentionW: "",
                //     productDimentionH: "",
                //     productDescription: "",
                //     productTags: [],
                //     productImage: [],
                //     productVarient: [],
                //     productStatus: user?.role === "Superadmin" ? true : false,
                //     productUnderReview: false,
                //   },
                // }));
              }}
            >
              Add Product
            </Button>
          </Box>
        </Box>
      )}
      <Box>
        {tableData?.length > 0 && (
          <SimpleBar
            forceVisible="x"
            autoHide={true}
            style={{
              overflowX: "auto",
              maxHeight: "63vh",
            }}
            className="custom-scrollbar"
          >
            <Box sx={{ display: "contents" }}>
              <Paper
                sx={{
                  width: "100%",
                  // height: "75vh",
                  border: "1px solid #E5E5E8",
                  borderRadius: "4px",
                }}
              >
                <DataTableComponent
                  data={tableData || []}
                  columns={CataloguesColumns}
                  customStyles={{
                    table: {
                      style: {
                        borderCollapse: "collapse",
                      },
                    },
                    headCells: {
                      style: {
                        borderRight: "1px solid rgba(229, 229, 232, 1)",
                      },
                    },
                    cells: {
                      style: {
                        borderRight: "1px solid rgba(229, 229, 232, 1)",
                      },
                    },
                  }}
                />
              </Paper>
            </Box>
          </SimpleBar>
        )}
        {tableData && tableData.length <= 0 && (
          <Box sx={{ marginTop: "10%", alignItems: "center" }}>
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <img src={issue} alt="issue_not_found" />
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                marginTop: "30px",
              }}
            >
              <Typography sx={{ fontWeight: 700, fontSize: "16px" }}>
                No records found
              </Typography>
            </Box>
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#5E17EB",
                  color: "#fff",
                  border: "1px solid #E5E5E8",
                  borderRadius: "4px",
                  boxShadow: "none",
                  whiteSpace: "nowrap",
                  fontWeight: 600,
                  marginTop: "20px",
                  "&:hover": {
                    outline: "none",
                    color: "#fff",
                    backgroundColor: "#5E17EB", // Remove border color on focus
                  },
                }}
                onClick={() => {
                  setAddProductFromOverview(true);
                  setAddProductFromOverviewDocId(id);
                  navigate("/shopping/store/add-product");
                  setCheckForEdit(false);
                  setProductIdForEdit("");
                  setAddProductFromOverview(false);
                  setProductCatalog(false);
                  setStoreFormData((prev) => ({
                    ...prev,
                    currentProduct: {
                      productId: "",
                      productName: "",
                      productCategory: "",
                      productBrand: "",
                      productPrice: "",
                      productWeight: "",
                      productStock: "",
                      productDimentionL: "",
                      productDimentionW: "",
                      productDimentionH: "",
                      productDescription: "",
                      productTags: [],
                      productImage: [],
                      productVarient: [],
                      productStatus: user?.role === "Superadmin" ? true : false,
                      productUnderReview: false,
                    },
                  }));
                }}
              >
                Add Product
              </Button>
            </Box>
          </Box>
        )}
      </Box>
      <ConfirmationModal
        showModal={confirmatioModalState.showModal}
        submitHandler={() => deleteHandler()}
        submitText={"Delete"}
        cancelText={"Cancel"}
        cancelHandler={cancelHandler}
        headerText={"Are you sure?"}
        bodyText={"You want to delete this store"}
      />
    </Box>
  );
}

export default CataloguesList;
